module.exports = __webpack_public_path__ + "static/media/burbuja1.9dd943c7.png";